import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PackageCard from "./PackageCard";
import Loader from "../../components/Loader/Loader";
import CustomPagination from "../../components/pagination/CustomPagination";
import { getAllPackagesList } from "../../api/pricingplan";

function AllPackagesPage() {
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    nextPage: null,
    prevPage: null,
  });
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(3);
  const options = [3, 6, 9];

  const handleSelect = (value) => {
    setCount(value);
    setOpen(false);
  };

  const fetchPackages = async (page = 1) => {
    setLoading(true);
    try {
      const res = await getAllPackagesList({
        user_id: userId, // pass this properly
        page,
        perPage: count, // dynamic pagination
      });

      if (res?.data) setPackages(res.data);

      if (res?.pagination) {
        setPagination({
          currentPage: res.pagination.currentPage,
          totalPages: res.pagination.totalPages,
          nextPage: res.pagination.nextPage,
          prevPage: res.pagination.previousPage,
        });
      }

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Could not fetch packages", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPackages(1);
  }, [count]);

  return (
    <div>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          padding: "1rem",
        }}
      >
        {/* Back Button */}
        <button
          onClick={() => navigate("/sap/pricing-plan")}
          style={{
            position: "absolute",
            left: "2rem",
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#F1E5F8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <img
            src="/SAPImages/pricing/Vector (7).png"
            alt="Back"
            style={{ width: "16px", height: "16px", objectFit: "contain" }}
          />
        </button>

        {/* Page Title */}
        <h1
          style={{
            fontFamily: "Inter",
            fontWeight: 400,
            fontStyle: "normal",
            fontSize: "30px",
            lineHeight: "100%",
            textAlign: "center",
            margin: 0,
          }}
        >
          Available <span style={{ color: "#572575" }}>Packages</span>
        </h1>
      </div>

      {/* Loader / Empty / Packages */}
      {loading ? (
        <Loader text="Loading Packages..." />
      ) : packages.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "3rem 1rem",
            backgroundImage: "url('/SAPImages/pricing/image 2816.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
            minHeight: "400px",
            marginTop: "1rem",
          }}
        >
          <img
            src="/SAPImages/pricing/Group (5).png"
            alt="No packages"
            style={{ width: "178px", height: "231px", marginBottom: "1.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "24px",
              textAlign: "center",
              marginBottom: "0.5rem",
            }}
          >
            No packages found
          </Typography>
        </div>
      ) : (
        <>
          <div className="relative w-fit">
            {/* Main button */}
            <button
              onClick={() => setOpen(!open)}
              className="flex items-center gap-2 border border-[#E7CEF6] bg-white rounded-xl shadow-[0px_2px_4px_0px_#F4D3ED] px-4 py-2 text-[#572575] font-[Altis_UniSA] font-bold text-sm cursor-pointer"
            >
              Show {count}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="#572575"
                className={`w-4 h-4 transition-transform duration-200 ${
                  open ? "rotate-180" : "rotate-0"
                }`}
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {/* Dropdown menu */}
            {packages.length > 0 && open && (
              <div className="absolute left-0 mt-2 w-full bg-white border border-[#E7CEF6] rounded-xl shadow-[0px_2px_6px_0px_#EAD0F3] z-10">
                {options.map((opt) => (
                  <div
                    key={opt}
                    onClick={() => handleSelect(opt)}
                    className={`px-4 py-2 text-sm font-[Altis_UniSA] font-semibold text-[#572575] cursor-pointer hover:bg-[#F8F2FB] ${
                      count === opt ? "bg-[#F3E2FB]" : ""
                    }`}
                  >
                    {opt}
                  </div>
                ))}
              </div>
            )}
          </div>
          <Grid container spacing={3} sx={{ marginTop: "0.5rem" }}>
            {packages.map((pkg, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <PackageCard {...pkg} />
              </Grid>
            ))}
          </Grid>

          {/* Pagination */}
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CustomPagination
              pagination={pagination}
              onPageChange={(page) => fetchPackages(page)}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default AllPackagesPage;
